export interface Work {
  id: string;
  title: string;
  year: number;
  type: string;
  director: string;
  cast: string[];
  duration: string;
  summary: string;
  description: string[];
  cover: string;
  gallery: string[];
  tags: string[];
  hot: number;
}

export const works: Work[] = [
  {
    id: "huihuang-zhilu",
    title: "辉煌之路",
    year: 2024,
    type: "电影",
    director: "佐藤健一",
    cast: ["濑户环奈", "高桥隼人", "中村美咲"],
    duration: "128 分钟",
    summary: "一部关于梦想与抉择的青春群像电影，濑户环奈饰演在都市中追寻舞台梦想的舞者。",
    description: [
      "《辉煌之路》以东京都市圈为舞台，讲述三位年轻人在理想与现实之间反复拉扯的成长故事。濑户环奈饰演的女主角绫濑是一个从小镇来到东京追寻舞蹈梦想的女孩，她在一次次失败与质疑中重新定义了自己的价值。",
      "影片采用大量长镜头与自然光拍摄，将演员的情绪变化细腻地呈现在银幕之上。濑户环奈为角色接受了为期半年的专业舞蹈训练，片中多场独舞段落均由本人完成。",
      "该片上映后口碑与票房双丰收，被认为是濑户环奈表演生涯的重要转折点。影评人评价她的表演“克制而富有层次，把角色的倔强与脆弱同时演了出来”。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20an%20elegant%20dress%2C%20soft%20warm%20studio%20lighting%2C%20sakura%20pink%20and%20cream%20tones%2C%20editorial%20film%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-01-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20dancing%20on%20a%20city%20rooftop%20at%20golden%20hour%2C%20cinematic%20wide%20shot%2C%20warm%20tones%2C%20soft%20natural%20lighting%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-01-still&orientation=landscape",
    ],
    tags: ["电影", "青春", "励志", "东京"],
    hot: 98,
  },
  {
    id: "yinghua-zhixia",
    title: "樱花之下",
    year: 2023,
    type: "电视剧",
    director: "小林由美",
    cast: ["濑户环奈", "山田凉介", "石原里美"],
    duration: "全 10 集",
    summary: "以樱花盛开的京都为背景的都市情感剧，濑户环奈饰演经营老铺和果子店的年轻女社长。",
    description: [
      "《樱花之下》围绕一家传承三代的京都和果子老铺展开，濑户环奈饰演的年轻女社长在家族传统与商业革新之间寻找平衡。剧集以四季更替为叙事线索，展现了一个关于守护与传承的温柔故事。",
      "濑户环奈在剧中展现了细腻的表演，她与老戏骨们的对手戏被认为是整部剧的高光时刻。剧中大量京都实景拍摄，画面质感极佳。",
      "该剧播出期间连续多周占据话题榜前列，主题曲与取景地均成为观众热议的对象。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%2C%20soft%20warm%20studio%20lighting%2C%20sakura%20pink%20and%20cream%20tones%2C%20elegant%20fashion%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-02-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20standing%20under%20blooming%20cherry%20blossom%20trees%20in%20kyoto%20street%2C%20cinematic%20wide%20shot%2C%20warm%20pastel%20tones%2C%20soft%20natural%20lighting%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=work-02-still&orientation=landscape",
    ],
    tags: ["电视剧", "情感", "京都", "传承"],
    hot: 92,
  },
  {
    id: "dongjing-wangshi",
    title: "东京往事",
    year: 2022,
    type: "电影",
    director: "中岛哲也",
    cast: ["濑户环奈", "役所广司", "满岛光"],
    duration: "142 分钟",
    summary: "跨越三十年的家族史诗，濑户环奈饰演在时代洪流中坚守旧书店的第二代继承人。",
    description: [
      "《东京往事》以一家位于神保町的旧书店为线索，串联起一个家族三代人在战后日本社会变迁中的命运起伏。濑户环奈饰演的第二代继承人，是整部影片情感的核心。",
      "影片采用非线性叙事结构，通过精巧的时空交错展现记忆与现实的重量。濑户环奈在不同年代的造型转换跨度极大，表演功力备受肯定。",
      "该片入围多个国际电影节主竞赛单元，被誉为近年最动人的日本家族题材电影之一。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20vintage%20style%20clothing%2C%20warm%20sepia%20tones%2C%20soft%20studio%20lighting%2C%20editorial%20film%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-03-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=quiet%20old%20bookstore%20alley%20in%20tokyo%20with%20warm%20afternoon%20light%2C%20woman%20holding%20a%20book%2C%20cinematic%20wide%20shot%2C%20warm%20amber%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-03-still&orientation=landscape",
    ],
    tags: ["电影", "家族", "年代", "文艺"],
    hot: 88,
  },
  {
    id: "jingye-zhi-shi",
    title: "静夜之诗",
    year: 2021,
    type: "电视剧",
    director: "坂元裕二",
    cast: ["濑户环奈", "松隆子", "星野源"],
    duration: "全 8 集",
    summary: "聚焦深夜电台主播都市孤独生活的治愈系剧集，濑户环奈饰演一档深夜节目的主持人。",
    description: [
      "《静夜之诗》讲述一位深夜电台主持人与听众之间通过电波建立联结的故事。濑户环奈饰演的主播用声音陪伴着城市里那些无法入睡的人，也在过程中治愈了自己。",
      "剧集结构精巧，每集围绕一个听众的故事展开，台词细腻且富有诗意。濑户环奈的旁白被认为赋予了整部剧独特的温度。",
      "该剧以低预算制作却收获了极高口碑，被许多观众列为年度最爱日剧。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20moody%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20dim%20warm%20light%2C%20soft%20studio%20lighting%2C%20muted%20cream%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-04-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=woman%20speaking%20into%20a%20radio%20microphone%20in%20a%20dim%20warm%20lit%20studio%20at%20night%2C%20cinematic%20wide%20shot%2C%20moody%20amber%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-04-still&orientation=landscape",
    ],
    tags: ["电视剧", "治愈", "都市", "广播"],
    hot: 85,
  },
  {
    id: "haibian-de-xin",
    title: "海边的信",
    year: 2025,
    type: "电影",
    director: "是枝裕和",
    cast: ["濑户环奈", "阿部宽", "树木希林"],
    duration: "135 分钟",
    summary: "一封迟到十年的信件引出的海边小镇故事，濑户环奈饰演回到故乡寻找答案的女儿。",
    description: [
      "《海边的信》是一部安静而深沉的电影，讲述女主角在母亲去世后回到海边小镇，通过一封封旧信重新认识自己与家人的故事。",
      "濑户环奈在片中大量使用无台词的眼神表演，将角色的内疚、释怀与和解层层递进地呈现出来。海边的四季光影构成了影片的诗意底色。",
      "影片在第若干国际影展收获好评，被认为是濑户环奈最内敛成熟的一次演出。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20natural%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20by%20the%20sea%2C%20soft%20overcast%20lighting%2C%20muted%20blue%20grey%20and%20cream%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-05-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20walking%20along%20a%20quiet%20seaside%20town%20shoreline%20at%20dusk%2C%20cinematic%20wide%20shot%2C%20soft%20muted%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-05-still&orientation=landscape",
    ],
    tags: ["电影", "亲情", "海边", "文艺"],
    hot: 90,
  },
  {
    id: "chuxue",
    title: "初雪",
    year: 2020,
    type: "电影",
    director: "岩井俊二",
    cast: ["濑户环奈", "松田龙平", "广濑铃"],
    duration: "118 分钟",
    summary: "发生在初雪之日的青春爱情故事，濑户环奈饰演等待恋人归来却等来告别的高中女生。",
    description: [
      "《初雪》是一部关于初恋与遗憾的青春电影，故事发生在北方的一座小城。濑户环奈饰演的女主角在漫天飞雪中等待一场注定不会到来的重逢。",
      "影片色调清冷而干净，大量留白式构图与钢琴配乐共同营造出淡淡的哀愁。濑户环奈的青涩气质与角色高度契合。",
      "该片是她早期的重要作品，让更多观众记住了这张清新的面孔。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20a%20light%20winter%20coat%2C%20soft%20cool%20lighting%2C%20white%20and%20soft%20pink%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-06-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20standing%20in%20falling%20snow%20on%20a%20quiet%20street%2C%20cinematic%20wide%20shot%2C%20soft%20white%20and%20pale%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-06-still&orientation=landscape",
    ],
    tags: ["电影", "爱情", "青春", "冬季"],
    hot: 82,
  },
  {
    id: "guangying-zhijian",
    title: "光影之间",
    year: 2024,
    type: "电视剧",
    director: "大根仁",
    cast: ["濑户环奈", "菅田将晖", "永野芽郁"],
    duration: "全 12 集",
    summary: "聚焦影视行业幕后生态的职场剧，濑户环奈饰演从场记一步步成长起来的年轻摄影师。",
    description: [
      "《光影之间》把镜头对准了电影工业的幕后，讲述一位年轻摄影师在片场摸爬滚打、追逐光影梦想的故事。濑户环奈饰演的角色要在男性主导的行业中证明自己。",
      "剧集细节考究，真实还原了片场的工作流程与行业生态。濑户环奈与菅田将晖的对手戏张力十足，两人亦师亦友的关系成为剧集看点。",
      "该剧播出后引发行业内外的广泛讨论，也让不少观众第一次了解摄影指导这份工作。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20holding%20a%20camera%2C%20warm%20studio%20lighting%2C%20cream%20and%20amber%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-07-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=woman%20photographer%20with%20camera%20on%20a%20film%20set%20with%20lights%20and%20equipment%2C%20cinematic%20wide%20shot%2C%20warm%20amber%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-07-still&orientation=landscape",
    ],
    tags: ["电视剧", "职场", "行业", "成长"],
    hot: 89,
  },
  {
    id: "xiari-huisheng",
    title: "夏日回声",
    year: 2019,
    type: "电影",
    director: "冲田修一",
    cast: ["濑户环奈", "加濑亮", "桥本爱"],
    duration: "112 分钟",
    summary: "濑户环奈的银幕出道作品，讲述夏日小岛上几个年轻人短暂的相遇与离别。",
    description: [
      "《夏日回声》是一部充满夏日气息的青春群像电影，也是濑户环奈正式登上大银幕的出道之作。她饰演一个到小岛度过暑假的都市少女。",
      "影片节奏舒缓，海风、蝉鸣与旧唱片构成了整部电影的听觉记忆。濑户环奈身上那种未经雕琢的灵气成为了影片最大的亮点。",
      "虽然当时戏份不多，但她已经显露出日后成为实力派演员的潜质。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sunny%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20a%20light%20summer%20dress%2C%20warm%20natural%20lighting%2C%20cream%20and%20sky%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-08-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20cycling%20along%20a%20sunny%20seaside%20island%20road%20in%20summer%2C%20cinematic%20wide%20shot%2C%20warm%20bright%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-08-still&orientation=landscape",
    ],
    tags: ["电影", "青春", "夏日", "出道作"],
    hot: 78,
  },
  {
    id: "weiwan-de-shi",
    title: "未完的诗",
    year: 2022,
    type: "电视剧",
    director: "宫藤官九郎",
    cast: ["濑户环奈", "瑛太", "安藤樱"],
    duration: "全 9 集",
    summary: "一位患病的诗人与年轻编辑之间的故事，濑户环奈饰演为整理遗稿而走进诗人世界的编辑。",
    description: [
      "《未完的诗》讲述年轻文学编辑受命整理一位隐退诗人未发表的手稿，在过程中逐渐走进对方内心世界的故事。濑户环奈饰演的编辑聪明而执着。",
      "剧集对文学与出版行业的描写细腻真实，每集以一首未完成的诗作为线索推进。濑户环奈与瑛太的对手戏充满智性火花。",
      "该剧台词富有文学性，被观众称为“需要慢慢品”的作品。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20holding%20old%20papers%2C%20soft%20warm%20library%20lighting%2C%20cream%20and%20brown%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-09-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20reading%20old%20manuscripts%20in%20a%20warm%20sunlit%20library%2C%20cinematic%20wide%20shot%2C%20warm%20cream%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-09-still&orientation=landscape",
    ],
    tags: ["电视剧", "文学", "文艺", "治愈"],
    hot: 80,
  },
  {
    id: "liming-zhiqian",
    title: "黎明之前",
    year: 2023,
    type: "电影",
    director: "白石和弥",
    cast: ["濑户环奈", "绫野刚", "妻夫木聪"],
    duration: "126 分钟",
    summary: "悬疑犯罪题材影片，濑户环奈首次挑战饰演追踪真相的年轻记者。",
    description: [
      "《黎明之前》是一部节奏紧凑的悬疑片，讲述一位年轻记者在调查一桩旧案时意外卷入更大阴谋的故事。濑户环奈首次挑战如此硬朗的角色类型。",
      "为了贴近角色，濑户环奈在开拍前深入采访了多位一线新闻工作者。片中的追查戏份与情绪爆发戏成为她表演的一次突破。",
      "影片在多伦多电影节首映后获得不俗评价，被认为是她拓宽戏路的重要作品。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20serious%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20a%20dark%20coat%2C%20moody%20dramatic%20lighting%2C%20cool%20charcoal%20and%20amber%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-10-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20journalist%20walking%20through%20a%20dim%20city%20street%20at%20dawn%2C%20cinematic%20wide%20shot%2C%20moody%20charcoal%20and%20amber%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-10-still&orientation=landscape",
    ],
    tags: ["电影", "悬疑", "犯罪", "记者"],
    hot: 91,
  },
  {
    id: "yinzuo-zhiye",
    title: "银座之夜",
    year: 2025,
    type: "电视剧",
    director: "西谷弘",
    cast: ["濑户环奈", "木村拓哉", "泽尻英龙华"],
    duration: "全 11 集",
    summary: "以银座高级俱乐部为舞台的华丽群像剧，濑户环奈饰演崭露头角的年轻老板娘。",
    description: [
      "《银座之夜》把镜头对准了光怪陆离的银座夜世界，讲述一位年轻女性在名店林立的街区中努力闯出自己一片天的故事。濑户环奈饰演的老板娘聪慧而果断。",
      "剧集美术与服装极尽考究，完美还原了银座夜晚的奢华气息。濑户环奈在剧中的多套造型成为时尚话题。",
      "该剧是当季话题度最高的日剧之一，收视与讨论度居高不下。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20glamorous%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20an%20elegant%20evening%20dress%2C%20warm%20dramatic%20night%20lighting%2C%20gold%20and%20rose%20tones%2C%20editorial%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-11-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20in%20an%20elegant%20evening%20dress%20in%20a%20glamorous%20ginza%20night%20street%2C%20cinematic%20wide%20shot%2C%20warm%20gold%20and%20rose%20tones%2C%20film%20still%20photography%2C%20high%20detail&width=1600&height=900&seq=work-11-still&orientation=landscape",
    ],
    tags: ["电视剧", "都市", "女性", "时尚"],
    hot: 94,
  },
  {
    id: "fengzhigu",
    title: "风之谷",
    year: 2026,
    type: "电影",
    director: "新海诚",
    cast: ["濑户环奈", "神木隆之介", "长泽雅美"],
    duration: "130 分钟",
    summary: "备受期待的最新电影，濑户环奈主演一部关于自然与重生的奇幻题材作品。",
    description: [
      "《风之谷》是濑户环奈即将于 2026 年上映的最新主演电影，故事发生在一个人与自然逐渐和解的架空世界，她饰演一位守护山谷的少女。",
      "影片大量采用实景与视效结合的方式拍摄，濑户环奈在片中有许多与自然互动的戏份。制作团队历时三年打磨，被视为年度最受期待的作品。",
      "目前影片已公布先导预告，濑户环奈的造型与影片世界观引发粉丝热烈讨论。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20ethereal%20portrait%20of%20a%20young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20flowing%20natural%20clothing%2C%20soft%20dreamy%20lighting%2C%20sage%20green%20and%20cream%20tones%2C%20fantasy%20poster%20photography%2C%20high%20detail&width=900&height=1200&seq=work-12-cover&orientation=portrait",
    gallery: [
      "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20standing%20in%20a%20misty%20green%20valley%20with%20tall%20grass%2C%20cinematic%20wide%20shot%2C%20soft%20dreamy%20sage%20green%20tones%2C%20fantasy%20film%20still%2C%20high%20detail&width=1600&height=900&seq=work-12-still&orientation=landscape",
    ],
    tags: ["电影", "奇幻", "最新作品", "自然"],
    hot: 99,
  },
];